import _reduxForm from "redux-form/es/reduxForm";
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { OUT_OF_STOCK_EMAIL_SUBSCRIPTION } from 'swag-client-common/constants';
import { subscribeUserToOutOfStockProduct } from '../../../../../../redux/product/product.actions';
import { outOfStockTextSelector, outOfStockTitleSelector } from '../../../../../../redux/out-of-stock/out-of-stock.selectors';
import { isLimitedEditionSelector } from '../../../../../../redux/product/product.selectors';
import OutOfStock from './out-of-stock';
const mapDispatchToProps = dispatch => ({
  onSubmit: data => {
    dispatch(subscribeUserToOutOfStockProduct(data));
  }
});
const mapStateToProps = createStructuredSelector({
  title: outOfStockTitleSelector,
  text: outOfStockTextSelector,
  isLimitedEdition: isLimitedEditionSelector
});
export default connect(mapStateToProps, mapDispatchToProps)(_reduxForm({
  form: OUT_OF_STOCK_EMAIL_SUBSCRIPTION,
  initialValues: {
    email: ''
  }
})(OutOfStock));